import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import SettingsMenuComponent from '../components/SettingsMenu/SettingsMenuComponent';
import UserSettingsPage from './UserSettingsPage';
import TradeReportPage from './TradeReportPage';
import TradeSettingsPage from '@alphapoint/apex-web/lib/components/Settings/TradeSettings';
import APIKeysPage from './APIKeysPage';
import UserContactsPage from './UserContactsPage';
import AffiliateProgramPage from './AffiliateProgramPage';
import LoyaltyTokenPage from './LoyaltyTokenPage';
import DemoSettingsContainer from '@alphapoint/apex-web/lib/components/Settings/DemoSettings/DemoSettingsContainer';
import InterestBearingAccountsSettingsContainer from '@alphapoint/apex-web/lib/components/Settings/InterestBearingAccounts/';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import { marginSystemEnabledSelector } from '@alphapoint/apex-web/lib/redux/margin/selectors';
import KYCSettings from '@alphapoint/apex-web/lib/components/KYCSettings';
import './SettingsPage.css';

const settingsPageClasses = getBEMClasses('settings-page');

const SettingsPage = ({ systemMarginEnabled }) => (
  <React.Fragment>
    <div className={settingsPageClasses('container')}>
      <div className={settingsPageClasses('menu')}>
        <SettingsMenuComponent systemMarginEnabled={systemMarginEnabled} />
      </div>
      <div className={settingsPageClasses('content')}>
        <Route path={'/settings/user'} component={UserSettingsPage} />
        {systemMarginEnabled && <Route path="/settings/trade" component={TradeSettingsPage} />}
        <Route path="/settings/iba" component={InterestBearingAccountsSettingsContainer} />
        <Route path={'/settings/trade-reports'} component={TradeReportPage} />
        <Route path={'/settings/api-keys'} component={APIKeysPage} />
        <Route path={'/settings/contacts'} component={UserContactsPage} />
        <Route path={'/settings/affiliate'} component={AffiliateProgramPage} />
        <Route path={'/settings/loyalty-token'} component={LoyaltyTokenPage} />
        <Route path={'/settings/verification-level'} component={KYCSettings} />
        <Route path={'/settings/demo-settings'} component={DemoSettingsContainer} />
      </div>
    </div>
    <div className={settingsPageClasses('footer')}>
      <PageFooterLayout />
    </div>
  </React.Fragment>
);

export default connect((state) => ({
  systemMarginEnabled: marginSystemEnabledSelector(state),
}))(SettingsPage);
